var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline-block"},[_c('ColorTextBtn',{staticClass:"line",on:{"click":_vm.deleteShop}},[_vm._v(" 删除 ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }